export const tallViewportPanelLiftSx = {
  '@media (min-height: 1000px)': {
    transform: { sm: 'translateY(clamp(-80px, -5dvh, -48px))' },
  },
} as const;
